<template>
  <div>
    <v-data-table :headers="headers" :items="calendarFeeds" :items-per-page="10">
      <template v-slot:item.valid="{ item }">
        <v-icon color='red' left v-if="item.error === true">mdi-minus-circle-off</v-icon>
        <v-icon color='green' left v-else>mdi-check-circle</v-icon>
      </template>
      <template v-slot:item.active="{ item }">
        <v-icon color='green' left v-if="item.active === true">mdi-check-circle</v-icon>
        <v-icon color='grey' left v-else>mdi-minus-circle-off</v-icon>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="lighten-3" class="mx-2" icon small v-on="on" v-bind="attrs">
              <v-icon small>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list class="options-list">
            <v-list-item>
              <confirmation
                :title="$t('page-unit-ical-sync.actions.delete-feed.confirmation-header')"
                :submitHandler="deleteSubmitHandler"
                :entity="item"
                >
                <template v-slot:activator="props">
                  <v-list-item-title @click.stop="props.showDialog">
                    {{ $t('global-terms.delete') }}
                  </v-list-item-title>

                </template>
                <template v-slot:body>
                    <p>{{$t('page-unit-ical-sync.actions.delete-feed.confirmation-body')}}</p>
                </template>
              </confirmation>
            </v-list-item>
            <v-list-item v-if="item.active === true && (currentUserHasRole('Administrator') || currentUserHasRole('Membership'))">
              <confirmation
                :title="$t('page-unit-ical-sync.actions.deactivate-feed.confirmation-header')"
                :submitHandler="deactivateSubmitHandler"
                :entity="item"
                >
                <template v-slot:activator="props">
                  <v-list-item-title @click.stop="props.showDialog">
                    {{ $t('global-terms.deactivate') }}
                  </v-list-item-title>
                </template>
                <template v-slot:body>
                    <p>{{$t('page-unit-ical-sync.actions.deactivate-feed.confirmation-body')}}</p>
                </template>
              </confirmation>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:item.channel.name="{ item }">
        <span :class="{'grey--text text--lighten-1': item.active === false}">
          {{ item.channel.name }}
        </span>
      </template>
      <template v-slot:item.url="{ item }">
        <span :class="{'grey--text text--lighten-1': item.active === false}">
          {{ item.url }}
        </span>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import Confirmation from '@/components/dialogs/Confirmation'
import { useUserStore, useUnitCalendarFeedStore } from '@/stores'
import { clone } from 'ramda'

export default {
  name: 'synced-channels-table',
  props: {
    calendarFeeds: {
      type: Array,
      required: true,
    },
    channels: {
      type: Array,
      required: true,
    },
    unit: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState(useUserStore, ['currentUserHasRole']),
    headers () {
      let headers = [
        { width: 200, sortable: false, text: this.$t('page-unit-ical-sync.section-other-channels-to-sawdays.fields.channel.label'), value: 'channel.name' },
        { sortable: false, text: this.$t('page-unit-ical-sync.section-other-channels-to-sawdays.fields.feed.label'), value: 'url' },
        { sortable: false, align: 'end', value: 'valid', text: 'Valid?' },
      ]

      // TODO: remove when removing propsync
      if (this.unit.syncing === true || this.currentUserHasRole('Administrator') || this.currentUserHasRole('Membership')) {
        headers.push({ sortable: false, align: 'end', value: 'active', text: 'Active?' })
      }

      headers.push({ sortable: false, align: 'end', value: 'actions' })

      return headers
    },
  },
  methods: {
    clone,
    ...mapActions(useUnitCalendarFeedStore, [
      'httpDeleteUnitCalendarFeed',
      'httpUpdateUnitCalendarFeed',
    ]),
    deleteSubmitHandler (calendarFeed) {
      const cloneUnit = this.clone(this.unit)
      return this.httpDeleteUnitCalendarFeed({ calendarFeed, unit: cloneUnit })
    },
    deactivateSubmitHandler (calendarFeed) {
      let updateCalendarFeed = {
        id: calendarFeed.id,
        active: false,
      }

      return this.httpUpdateUnitCalendarFeed({
        calendarFeed: updateCalendarFeed,
        args: {
          successMessage: this.$t('page-unit-ical-sync.actions.deactivate-feed.toast-success'),
          errorMessage: this.$t('page-unit-ical-sync.actions.deactivate-feed.toast-error'),
        },
      })
    },
  },
  components: {
    Confirmation,
  },
}
</script>
<style lang="scss" scoped>
.options-list {
  .v-list-item {
    border-bottom: 1px solid grey;
    &:last-child{
      border: none;
    }
    &:hover {
      cursor: pointer;
      background: rgb(237, 237, 237);
    }
  }
}
</style>
